import React, { useRef, useState } from 'react'
import {
  Container,
  CenteredSpinner,
  Col
} from 'react-angle-dashboard-components'
import { FormData } from '../../interfaces/claims'
import { useQuery } from 'react-query'
import { claimsService } from '../../services'
import { SearchResults } from './SearchResults/SearchResults'
import { SearchForm } from './SearchForm/SearchForm'
import {
  GetClaimsByMemberReqBody,
  GetClaimsByNumberReqBody
} from '../../services/claims'
import moment from 'moment'

// const emptyForm = {
//   providerId: '1912939786',
//   claimNumber: '222-0000020562-00',
//   memberId: '235244501',
//   billedAmount: '819.00',
//   dateOfBirth: '1965-01-23'
// }

const emptyForm = {
  providerId: '',
  claimNumber: '',
  memberId: '',
  billedAmount: '',
  dateOfBirth: ''
}

const emptyClaimNumberQuery = {
  provider_id: '',
  claim_number: ''
}

const emptyMemberQuery = {
  provider_id: '',
  angle_id: '',
  date_of_birth: '',
  billed_amount: 0,
  first_name: '',
  last_name: ''
}
export const ClaimsSearchContent = () => {
  const [queryEnabled, setQueryEnabled] = useState(false)

  const [clearDataTime, setClearDataTime] = useState('')
  const [formData, setFormData] = useState<FormData>(emptyForm)

  const [hasClaimNumber, setHasClaimNumber] = useState(true)

  const [message, setMessage] = useState<string | undefined>(undefined)

  // Using 2 separate states for the query values to send to API and the form values, because we have to clear the form inputs while still showing the query results
  const [claimNumberQuery, setClaimNumberQuery] =
    useState<GetClaimsByNumberReqBody>(emptyClaimNumberQuery)

  const [claimMemberQuery, setClaimMemberQuery] =
    useState<GetClaimsByMemberReqBody>(emptyMemberQuery)

  const queryFn = hasClaimNumber
    ? () => claimsService.getClaimsByClaimNumber(claimNumberQuery)
    : () => claimsService.getClaimsByMember(claimMemberQuery)

  const setNewQuery = (enabled: boolean) => {
    setQueryEnabled(enabled)
    setMessage('')
  }

  const clearResults = (msg?: string) => {
    setQueryEnabled(false)
    setClaimMemberQuery(emptyMemberQuery)
    setClaimNumberQuery(emptyClaimNumberQuery)
    setFormData(emptyForm)
    setMessage(msg)
  }

  const { data, isLoading } = useQuery(
    ['getClaims', hasClaimNumber, claimMemberQuery, claimNumberQuery],
    queryFn,
    {
      enabled: queryEnabled,
      refetchOnWindowFocus: false,
      retry: 0,
      onSuccess: (data) => {
        // clear form for HIPPA reasons (requirement is to leave form filled if error but clear if success)
        if ((data?.length ?? 0) > 0) {
          // only clear if we got some data back
          setFormData(emptyForm)
        }
      },
      onSettled: () => {
        const time = moment(new Date().getTime() + 10 * 1000 * 60).format(
          'hh:mm'
        )
        setClearDataTime(time)
        // clear all data after 10 minutes
        setTimeout(() => {
          clearResults()
        }, 1000 * 60 * 10)
      }
    }
  )

  // set individual claim toggle on table
  const [selected, setSelected] = useState<string | null>(null)
  const toggleSelect = (id: string) =>
    setSelected((current) => (id === current ? null : id))

  const showPrintBtn =
    data?.length && data?.length > 0 && queryEnabled ? true : false

  const printRef = useRef(null)
  const [formatForPrint, setFormatForPrint] = useState(false)
  const onBeforePrint = () => {
    setFormatForPrint(true)
    return new Promise(function (resolve) {
      setTimeout(resolve, 500)
    })
  }

  const onAfterPrint = () => {
    setFormatForPrint(false)
  }

  return (
    <Container style={{ padding: '80px 30px' }}>
      <SearchForm
        formData={formData}
        setFormData={setFormData}
        setNewQuery={setNewQuery}
        hasClaimNumber={hasClaimNumber}
        setHasClaimNumber={setHasClaimNumber}
        showPrintBtn={showPrintBtn}
        setClaimMemberQuery={setClaimMemberQuery}
        setClaimNumberQuery={setClaimNumberQuery}
        printRef={printRef}
        onBeforePrint={onBeforePrint}
        onAfterPrint={onAfterPrint}
      />
      {isLoading && <CenteredSpinner />}
      {queryEnabled && !isLoading && (
        <SearchResults
          ref={printRef}
          claims={data}
          toggleSelect={toggleSelect}
          selected={selected}
          searchQuery={hasClaimNumber ? claimNumberQuery : claimMemberQuery}
          clearDataTime={clearDataTime}
          formatForPrint={formatForPrint}
          clearResults={clearResults}
        />
      )}
      {message && (
        <Col
          className="mt-5 py-3 px-4 fs-20"
          sm={6}
          xs={12}
          style={{ background: 'rgba(35, 125, 131, 0.14)', borderRadius: 6 }}
        >
          Thank you, we'll be in touch soon!
        </Col>
      )}
    </Container>
  )
}
